<div class="card_gridTwo">
    <div class="projecttitle">
        <h3>EQUIPMENT STATUS</h3>
        <!-- <hr /> -->
    </div>

    <dx-chart [dataSource]="charts?.equipmentStatusData">
        <dxi-series type="bar" argumentField="block" valueField="equipments" name="Equipments" color="#f5c400"> </dxi-series>

        <dxi-series type="bar" argumentField="block" valueField="receivedEquipments" name="Received Equipments" color="#000000"> </dxi-series>
        <dxi-value-axis>
            <dxo-label [customizeText]="formatExactValue"> </dxo-label>

            <dxo-grid [visible]="true" color="#e0e0e0"></dxo-grid>
            <dxo-tick [visible]="false"></dxo-tick>
            <dxo-minor-tick [visible]="false"></dxo-minor-tick>
        </dxi-value-axis>

        <dxo-legend verticalAlignment="bottom" horizontalAlignment="center"> </dxo-legend>

        <dxo-tooltip [enabled]="true"></dxo-tooltip>
        <dxo-common-axis-settings>
            <dxo-tick [visible]="false"></dxo-tick>
            <dxo-minor-tick [visible]="false"></dxo-minor-tick>
        </dxo-common-axis-settings>
    </dx-chart>
</div>
<br />
<div class="card_gridTwo">
    <div class="projecttitle">
        <h3>JOINT DATA STATUS</h3>
    </div>

    <dx-chart [dataSource]="charts?.jointStatusData">
        <dxi-series type="bar" argumentField="block" valueField="receivedJoints" name="Received Joints" color="#f5c400"> </dxi-series>

        <dxi-series type="bar" argumentField="block" valueField="iDMSUploaded" name="IDMS Uploaded" color="#000000"> </dxi-series>

        <dxi-series type="bar" argumentField="block" valueField="tagsPrinted" name="Tags Printed" color="#9c27b0"> </dxi-series>

        <dxi-series type="bar" argumentField="block" valueField="jointsTagged" name="Joints Tagged" color="#4caf50"> </dxi-series>

        <dxi-value-axis>
            <dxo-label [customizeText]="formatExactValue"></dxo-label>
            <dxo-grid [visible]="true" color="#e0e0e0"></dxo-grid>
            <dxo-tick [visible]="false"></dxo-tick>
            <dxo-minor-tick [visible]="false"></dxo-minor-tick>
        </dxi-value-axis>

        <dxo-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
        <dxo-tooltip [enabled]="true"></dxo-tooltip>

        <dxo-common-axis-settings>
            <dxo-tick [visible]="false"></dxo-tick>
            <dxo-minor-tick [visible]="false"></dxo-minor-tick>
        </dxo-common-axis-settings>
    </dx-chart>
</div>
